// extracted by mini-css-extract-plugin
export default {"externalLinksContainer":"Jtm6TrB7Lw6FDZyM_Mkw"};